import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import actions from 'redux/actions'
import { constants } from 'common/helpers'
import { FormattedMessage } from 'sb-react-intl'

import CommonButton from 'components/buttons/CommonButton/CommonButton'

import Title from '../Title/Title'

import messages from './messages'
import s from './UpgradeSuccess.scss'


class UpgradeSuccess extends Component {

  static propTypes = {
    onClose: PropTypes.func,
  }

  componentWillUnmount() {
    const initialMonthIndex = 0

    actions.models.upgradeSubscriptionFlow.setCurrStep(constants.upgradeSubscriptionFlowSteps.selectPlan)
    actions.models.upgradeSubscriptionFlow.setActiveMonthIndex(initialMonthIndex)
  }

  render() {
    const { onClose } = this.props

    return (
      <div className={s.upgradeSuccess}>
        <Fragment>
          <Title message={messages.title} />
          <FormattedMessage {...messages.text} />
        </Fragment>
        {
          typeof onClose === 'function' && (
            <div className={s.action}>
              <CommonButton
                fullWidth
                brand
                close
                onClick={onClose}
                dataTestId={constants.testIds.modal.dialogModal.button}
              />
            </div>
          )
        }
      </div>
    )
  }
}


export default UpgradeSuccess
